export default __webpack_public_path__ + "static/media/bookThree@2x.35942ea7.png";